
import { NotificationSetting } from "@/types/settings";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface NotificationItemProps {
  setting: NotificationSetting;
  onToggleEmail: () => void;
  onToggleInApp: () => void;
  onFrequencyChange: (value: "immediate" | "daily" | "never") => void;
}

export const NotificationItem = ({
  setting,
  onToggleEmail,
  onToggleInApp,
  onFrequencyChange,
}: NotificationItemProps) => {
  return (
    <div className="border-b pb-4 last:border-b-0">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-3">
        <div>
          <h3 className="font-medium">{setting.label}</h3>
          <p className="text-sm text-muted-foreground">{setting.description}</p>
        </div>
        <div className="flex items-center gap-6">
          <div className="flex items-center space-x-2">
            <Label htmlFor={`email-${setting.key}`}>Email</Label>
            <Switch
              id={`email-${setting.key}`}
              checked={setting.email}
              onCheckedChange={onToggleEmail}
            />
          </div>
          
          <div className="flex items-center space-x-2">
            <Label htmlFor={`inapp-${setting.key}`}>In-App</Label>
            <Switch
              id={`inapp-${setting.key}`}
              checked={setting.inApp}
              onCheckedChange={onToggleInApp}
            />
          </div>
        </div>
      </div>
      
      <div className="flex items-center space-x-2 mt-3">
        <Label htmlFor={`frequency-${setting.key}`} className="w-20">Frequency</Label>
        <Select
          value={setting.frequency}
          onValueChange={onFrequencyChange}
        >
          <SelectTrigger id={`frequency-${setting.key}`} className="w-40">
            <SelectValue placeholder="Select frequency" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="immediate">Immediate</SelectItem>
            <SelectItem value="daily">Daily Digest</SelectItem>
            <SelectItem value="never">Never</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
